<template>
  <a-drawer
    :confirmLoading='confirmLoading'
    :keyboard='false'
    :maskClosable='false'
    title='系统质疑规则'
    :visible='visible'
    width='100%'
    @close='prev'>
    <a-spin :spinning='confirmLoading'>
      <a-steps  :current='current'>
        <a-step description='选择自动质疑对象' title='选择需要质疑规则自动质疑的表单字段'></a-step>
        <a-step description='设置规则数据源' title='设置质疑规则中包含的表单字段'></a-step>
        <a-step description='设置数据源周期' title='设置规则中各表单字段的周期信息'></a-step>
        <a-step description='设置条件' title='利用各表单字段值组成质疑条件'></a-step>
        <a-step description='设置质疑原因' title='对质疑进行说明'></a-step>
      </a-steps>
      <a-divider />
      <a-tabs v-model='current'>
        <a-tab-pane :key='0' tab=''>
          <step1 ref='step1' :model='model'></step1>
        </a-tab-pane>
        <a-tab-pane :key='1' tab=''>
          <step2 ref='step2' :model='model'></step2>
        </a-tab-pane>
        <a-tab-pane :key='2' tab=''>
          <step3 ref='step3' :model='model'></step3>
        </a-tab-pane>
        <a-tab-pane :key='3' tab=''>
          <step4 ref='step4' :model='model'></step4>
        </a-tab-pane>
        <a-tab-pane :key='4' tab=''>
          <step5 ref='step5' :model='model'></step5>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
    <div class='footer-btn'>
      <a-button style="margin-right: 12px" @click="prev">{{ cancelText }}</a-button>
      <a-button type="primary" @click="next">{{ okText }}</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { postAction,getAction } from '@api/manage'
import Step1 from '@views/tempconfig/sysQuestion/Step1'
import Step2 from '@views/tempconfig/sysQuestion/Step2'
import Step3 from '@views/tempconfig/sysQuestion/Step3'
import Step4 from '@views/tempconfig/sysQuestion/Step4'
import Step5 from '@views/tempconfig/sysQuestion/Step5'

export default {
  name: 'SysQuestionModel',
  components: { Step5, Step4, Step3, Step2, Step1 },
  props:{
    projectId:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      title: '新增质疑对象',
      visible: false,
      model: {},
      confirmLoading: false,

      current: -1,
      cancelText: '关闭',
      okText: '下一步',

    }
  },
  created() {
  },
  methods: {
    add() {
      //初始化默认值
      this.edit({})
    },
    edit(record) {
      const fn = (model)=>{
        this.current=-1
        // model.projectId=this.projectId
        this.model = Object.assign({}, model)
        this.visible = true
        this.next()
      }
      fn(record)
    },
    close() {
      this.model = {}
      this.$emit('close')
      this.visible = false
    },
    /*保存新增公式,触发请求*/
    handleOk() {
      const that = this
      this.$confirm({
        title: '再次确认',
        content: '确定要保存信息吗?',
        onOk() {
          that.confirmLoading = true
          postAction('/tempconfig/question/create', that.model).then((res) => {
            if (res.success) {
              that.$message.success(res.message)
              that.close()
              that.$emit('ok')
            } else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
            that.confirmLoading = false
          })
        },
        onCancel() {
        },
      })
    },

    handleCancel() {
      this.close()
    },
    /**
     * 下一步 每一步都需要验证表单
     */
    next() {
      let model =  this.model
      //当前步骤表单验证
      const step = this.$refs[`step${this.current+1}`]
      if (step ) {
        if(!step.validate()){
          return false
        }
        model = step.model
      }
      this.model = model
      const current = this.current+1
      switch (current) {
        case 0:
          break
        case 1:
          this.cancelText = '上一步'
          break
        case 2:
          break
        case 3:
          break
        case 4:
          this.okText = '确定'
          break
        case 5:
          //确定保存
          this.handleOk()
      }
      if(current <5){
        this.current  = current
        this.$nextTick(()=>{
          this.$refs[`step${this.current+1}`].view(model)
        })
      }
    },
    prev(e) {
      /*右上角关闭操作直接关闭*/
      if (!e.target.innerText) {
        this.handleCancel()
        return
      }
      switch (this.current) {
        case 0:
          this.handleCancel()
          break
        case 1:
          this.cancelText = '关闭'
          break
        case 2:
          break
        case 3:
          break
        case 4:
          this.okText = '下一步'
          break
      }
      if(this.current>=0){
        this.current--
      }
    },

  }

}
</script>

<style scoped>
/deep/ .ant-tabs-bar {
  display: none;
}

.footer-btn {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  /*background: #fff;*/
  border-radius: 0 0 4px 4px;
  z-index: 9;
  background: #F8F8F8;
}

/deep/.ant-drawer-header {
  background: #F8F8F8;
}


</style>
